module.exports = __webpack_public_path__ + "img/web4.06c6ab67.png";